import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (model) => (new PageHeader(1, ["Administration: FAQs"])), (_arg_2) => (!isEmpty(_arg_2) ? ((head(_arg_2) === "admin") ? (!isEmpty(tail(_arg_2)) ? ((head(tail(_arg_2)) === "faq") ? (isEmpty(tail(tail(_arg_2))) ? (new Page()) : undefined) : undefined) : undefined) : undefined) : undefined), (_arg_1) => ofArray(["admin", "faq"]), (_arg) => {
    if (_arg.tag === 22) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
